const mute = {
  color: `omegaDark`,
  textDecoration: `none`,
  userSelect: `none`,
  ':visited': {
    color: 'omegaDark'
  },
  ':hover': {
    color: 'alpha'
  }
}

export default mute